export enum DeheadingReportingTypeEnum{
    PARTIAL = 'PARTIAL',
    FULL = 'FULL'
}